import { render } from "./Today.vue?vue&type=template&id=272aa7cd"
import script from "./Today.vue?vue&type=script&lang=ts"
export * from "./Today.vue?vue&type=script&lang=ts"
script.render = render

export default script